import React from 'react';
import { LabelDetail, ValueDetail } from '../../../../component/page-components/detail';
import useDetailDataGroup from './detail-data-group.hooks';

const DataGroup = () => {
  const {
    data
  } = useDetailDataGroup();

  return (
    <>
      <div className=' mt-10 flex flex-col'>
        <div className=' mt-3 flex flex-row' >
          <div className=' w-96'>
            <LabelDetail children='Data Group ID' />
            <ValueDetail children={data?.id ? data?.id : '-' } />

            <LabelDetail children='Data Group Name' />
            <ValueDetail children={data?.data_group_id ? data?.data_group_id : "-" } />

            <LabelDetail children='Description' />
            <ValueDetail children={data?.description ? data?.description : '-' } />
          </div>
        </div>
      </div>
    </>
  );
}

export default DataGroup;